export default "__VITE_ASSET__b256d633__"